import { render, staticRenderFns } from "./add&edit.vue?vue&type=template&id=15e73952&scoped=true&"
import script from "./add&edit.vue?vue&type=script&lang=js&"
export * from "./add&edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e73952",
  null
  
)

export default component.exports